module.exports = {
	"trips": [
		{
			"totalCost": 433.2,
			"arrivalDateTime": "2018-06-15T11:44:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-06-15T07:15:00",
			"destination": "LAX",
			"downPayment": 144.4,
			"id": "18d38023-79c8-4ea9-88d9-61956a93e1b5",
			"origin": "ORD",
			"ppnReturnBundle": "_eJwN0keiqjAAAMADucDQWYJRIXQpQXdPkEAAIRQpp_f9_fzjAfoJ2VQgAHz9x1tjets9EUi39zV6jWFV63OK2zrEhE4aCBbxTbgU3xuT4VPtXwy_f4xxvcqyP_pQfAifc3ntR61IUiH8AxOfX6RhNNHH_fALA8iVvwzvXcN7glE4a6VsHH_f5aU4kXMVQb8s1nlHvbnq9IzoDfIo3S_piZiS7gJMRDk4Xskvlwc9JWU5WBYZU_fsK07j_fFl1I8B3W65vDyfsWrnWq9E_pPUMk_p5kKbzA56919g47Di285_fTiKv_fkv7gkLdLHNQHAc8UbWyWCopfuhfd6RJXBqF0j62cgUeknNi3ZRYCwSfcTxUPxqd9rytqOEn_fGMfffuss9Dy1yjmqca6LdP2TRt3tr_pCcA0fLP7jYP9XDjGqaaXGAkaRq3s3_ffsrAR89BOfdQ3HWtkI7yZ_pZtlaz_pRFDnZvetQv_pMSOzxrmKeqPZ2D89n0RsM5iBzHfoSOGrxfIutc8YMVUy1vdt9ngSmz60xswucGc7Uuc61idNCI1hDIhQzuv4eejLpBW9AAlQH0NPX1PUwR3ObGG_pyR97z9TOOKOVAf6ZdSOC0ME5daIw9yLXMA1_fvcNjUp9lJbYjKpcxAC_f_fcVPWXMaHeJxaXGP4LK_prDlwQoEW8zVrufsfmtcw1lxZ3S9paB7v1mquB7ALdTk9dE_pHZ9FXx0rOyHiOSHdhGNDWm9PuPK232oaS_pHGdHrcbPhSPjLYUhVXDjOk0eTL2J7RTyAIbYS9Y_flRT_pSLTeI1JsVa_f4we_f9S_fnHhHVDAGJ_puWhnmf7iEWR9qEamZH93GNZlOz5cUOrli0NNdcGYiF83eSWcsS3ddazbhzO4gndvhP80VawJKBOJfItOycqL5zEX2fICbdRq9XAbqVFDYzq_f_plQGrz4oAPleBdcTP_pS3ugbbSVbt5xtJYEKLVfJ7TR3Ek_f1e24fy1_pl5ssd3a7Q98Oitivi8Bac57oG2xdLglrmIRZ2IiwjHY3HPbqO5M8B2351PGX2su_pcVDqvsQP2gRhXUCHxkXcIHI8sWD5mCe3I_pCCqsbkdNnmfkk6xAiPhBuDuYYqzSmwkhYTcrktmYAa8Ggxxc04CVobM3BOR3_pb8ko_fl32VVLDiAK3_pC_p8Irjmz0rI11gnfwAXUg_pUgibxJ0EnDR6zGYp6b1nnAY1LPSIA_frUxEqyYKOcrn6W_fPF2cU46cMQUVLpftzT9FhZ6788QNV3DoPixCS_pF1pXw9HwUXH2KfLx3V5hVxh7klZtRES5I_pc6D9j6NfWG6IqQbf8Aabajqw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-06-15T09:01:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"departureDateTime": "2018-06-15T07:15:00",
					"flightNumber": "447",
					"aircraft": "Airbus A321",
					"aircraftType": "Jet",
					"destination": "PHX",
					"destinationAirportName": "Phoenix Sky Harbor Intl Airport",
					"destinationAirportCity": "Phoenix",
					"destinationAirportState": "AZ",
					"destinationAirportCountry": "United States",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-06-15T11:44:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"departureDateTime": "2018-06-15T10:00:00",
					"flightNumber": "760",
					"aircraft": "Airbus A321",
					"aircraftType": "Jet",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "PHX",
					"originAirportName": "Phoenix Sky Harbor Intl Airport",
					"originAirportCity": "Phoenix",
					"originAirportState": "AZ",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 434.4,
			"arrivalDateTime": "2018-06-15T14:43:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-06-15T08:10:00",
			"destination": "LAX",
			"downPayment": 144.8,
			"id": "4c7bd365-06a7-433e-bc6a-c64a323cb5d4",
			"origin": "ORD",
			"ppnReturnBundle": "_eJwN0MfCa0AAQOEHsojBKIu7IIPoPcpOjRKdKE9_f_f7P_fNidjaIYsSXzbtQDXU7bLi7ifvITBuGc4frRSNAgGdN6zw0p7AbuPx8_fBqYVahkpgwUjV1dMmFxfIotQQ_pgueaBkcNh9u3SVjnRC60lEdx4v1fMzMJkxRPIJLYOdu9G4tnPc_pkigz2l_pae1eJSHr2YfR7MYzMQrNN7WLIF69Zc8OqHUzxTDGv82tP9UKXumLzJ_fZvY0QcF1thDAuDBQpo4oBS6EEplCH_fKIuXxBa3b3a9HOAjAKciKflz9b1XhyftM8TGy5UMuA_fihkyQz01aWx580bpuChXq61w9VzB0WTRS2hv_fa0pb59ke9vmIbPuWS_pb9sQD_pm82J4atj3Zl3ektOEiXv47e6c4xi82ULI5TZWyhkm2HJ546xR6PFi9RI4lpw2Yaw_plGVph8TMpux7FchgU_f9CPf7WYMN5P7uJx9joJsDPMaL8zG45d3UTf7Ei8qaKqR253G6q5qskEGtokl51IqiDIHHPSzR7JXQ81Ix4Q6coHHe_f5sGRSz6_ffQJutVF3kujgg3L3bt9bz_foQimw2WmGF7Z_fas4GXlAgUvAjOPV6ivvIy6A3Hm2QK9MyX3J73Je_fHSBRGN5crkq1TArc5ozJCrfSRltoJNcRqQkxm9fBRVqFJLQuDli3lF3afI3S9Cfvx3MOc9jVqk87eu0yqgymy21j0Tvpw7Fdp3fhQ3Rymfnxy_fOCliSGj_fNJM3pq6Z_ppsjzLhwg11_pKbpKkzNfCAGcx4IIlQPV2uHKw7izBLlgjw7m5iCHT1VwlXHzPNsS46aEkoUlnaXTGr9fz_plbCcip66G8K_pZjypDbrsBcYya1Ea21o2jfSSy4Em7B5TvT1kadaGcZpDf7_pMpLpcNsKwj07u4mpk3Tc7rYP5KgNns6S8jEZm_foLTPosnUusE8MSrOmuEuFxC6PGe8S8Tt5Xh5zsei3ZUpXbd3BKe8yg1_p_pArCXYpgU7IZ3HV_pZ7PHu0_pIvaO1NspS_fCiPpHxNo7bR9ezd6mzhYMkLXRbNsWdvbHQYHM95J07Mc688Dv2jYH6VDtDorphWL5Waeep9bWaB6ANUGrRzKSkEtB_pqBzCkE7OQMbFO3CukNW_feyywow7kaRTHqKOyOHq0ELmqfG_f7KyGaz5i4plZ2LzkvpZ_pvIm_fwdisKwu7U8pWofvAIlU283MxTGoIcEIq55FHEdFjaF_fY7XCZJAdcVVsmbYoqd26VIRFTbuZ9QK6yoONOfkMc3JC5YPcwfrTFMhqXZpKEZpzdbOViZoB6TtbsERcmdzPn3H3EwosU",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-06-15T09:58:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-06-15T08:10:00",
					"flightNumber": "357",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "LAS",
					"destinationAirportName": "McCarran Intl Airport",
					"destinationAirportCity": "Las Vegas",
					"destinationAirportState": "NV",
					"destinationAirportCountry": "United States",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-06-15T14:43:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NK.png",
					"carrierCode": "NK",
					"carrierName": "Spirit Airlines",
					"departureDateTime": "2018-06-15T13:28:00",
					"flightNumber": "561",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "LAS",
					"originAirportName": "McCarran Intl Airport",
					"originAirportCity": "Las Vegas",
					"originAirportState": "NV",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 437.28,
			"arrivalDateTime": "2018-06-15T15:17:00",
			"numOfStops": 0,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-06-15T12:45:00",
			"destination": "LAX",
			"downPayment": 145.76,
			"id": "75be5a75-e8b5-444b-b5c7-817f8158dd76",
			"origin": "ORD",
			"ppnReturnBundle": "_eJwN0zWipEAAANEDdYAPEOLOoI1kuNuHwU6_fe4DKXhU4WaBUXsBz2uKWfdlyU9tt4XfW2QMSMVnEPEOe_pqM7Mq3nTq1elhleZBP1_p2fMwyhs_pFHXVHgHTmR4mBeyPfc6SpaytaoNYPrCIcy9x8HL102pwU_p63dHtT5jmlWRGlNPTru2ZCVjyxllaePaMsWbuE1D9l2NdnutFX_p9F6B0WJVyTWjyTehTmsk3VrgE3_fKIXe3S118hnRaESwX7KAwX3_fjsCXaVjohgJGcFxiwTxXfdRcZsDYYH11_fxl9LhxDfw4kmjhZiduOECved6qshkwwpys_fdrvFQrBR_fWcNTuCd5ULEfCd2lRCX0DKVSwkFzXfubCyu6_p6ldvXdqGdR4LcosM1Xe8sBuDAHK6pN1UtgYZ2u1TS9VBKamdqp8_fROY_fLbVVZDWBfUzK1CchbaIi7bWifhg9dWITZm68fhlsRzuPLyJb2O0R46fUZqDi1PgzZxeMCEdonMWRhkygtaM4WzfHTiJJB_pFmmY8edD16zpLfvX0tNP0n02tWcsKrBOfJLnh75hLV5RaNQdrJx_fs7D2kcSJqlZduUkESvFh630K63oGmcCVHDPr24t6PRZVqWxBVTNtt4UDOSm5jyIZU3cCrCRc_fFiHM5ioNKfi2M_fkvHNLbM8m2KDfrC235oCqGa5mkIwiVvdf1cl6Kq0Ls5_fhtdRV68trqn6qEfefdmgMjPMJsrEeVx9GMc0irO_fF4MZVV4yvc93uiLdXV1ewyap1BQjk3q_pj3GBtjBUR0h4IncPe7IY4cddsV0PprpubFTF_fxzJ4gzPXlpwFZi7X0K3kNRKC_fAiMhdEmcPH1UxqdUBe5nAkN28jj_pvPK3Kj_p0fpfvCWKCA0tNwEb5IolTQZNj2Fn9diVLQv16vqFOUZvw6d_fRCR5pEYMMqgicJrMA_pUgtpPaQzokhZJ8WFvYscGlGZuFRTp9ow4h_fD2Yo9_f_pPkmwZMFfGB6yqc9n_pTr5A1DDXZ0d_feclWSFcLQiPlZ68yL_f2Zn31gRDxC_pmALyiRVqOvm_fk4lF_f4hi5smIvlOjyoZKISnsUB_fVS1WP6_f2l1FPHy0vays20Th80r89xYLGN07LM5z73uqQBC9WKTmYVYnS2TdB9kJNPzOYzH4nGsiOQGDQjOuP_pq0gro8JmwPl4wKDoRlUDG_pYnhtGuUkCLjHe9ATE8wLLpSzDO2stutkS6qHqkiaDB2_foZ8MdgbH1S79L_fK35k2FowppXPZJw3QgtZF7B8OKpiG",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-06-15T15:17:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"departureDateTime": "2018-06-15T12:45:00",
					"flightNumber": "566",
					"aircraft": "Boeing 737-900",
					"aircraftType": "Jet",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 437.28,
			"arrivalDateTime": "2018-06-15T17:30:00",
			"numOfStops": 0,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-06-15T15:10:00",
			"destination": "LAX",
			"downPayment": 145.76,
			"id": "1d659818-0a15-46b2-8adc-2b022ff4f118",
			"origin": "ORD",
			"ppnReturnBundle": "_eJwN0UWSg0AAAMAHccBljgR3h8AtOAxOgr1_p9wldzWBMRWEMOH6_fq9xOFJfWEfOehdLhcSUVoAupEEMHzsPzjgWn5o_fFE0S7bRv6JAXTqPa0gM_fEvZppcl_fLZAyPX_pkCXOOhJL55jeaq0GKWYh9AaUBMEnPe9t41rar9WsqsJnKkyxihKD5bXq4EUK2rmHM5GgL_pAeUxgLnT09MQXwkka3mcqzC5X3ppfyiWUhJrnvZA9lhsbK20vb98Vw8_f_pRBGG9OyxJOlQAQb8PFrk1pDUKoeq8TY26ytsYsxEftI5Jfm0Tz6CxlO0zHMtEYVgrsmzQRnSIx3DuLzLaRh6p_fZHUAvxCmJEjxXL6p3ne8IdeaZ4rckxpBMxvmeUr7l8AYpX5cXasEvsKxno79diRVGBkc_fDTqWsONUY_pCD0ayRy1w3rm91igz2O1eUP1nLT97xle8_fPsnR3ooeuL_ptLitsPFUmM1Ez1CgQP1MMwZR8QCX2QddEF0yUw5iLTchXEcvyh1qutWLK5cPstfdemF4U_fc6Mpd7cOP1_pOPsM3e2hyAODVl7URcubi67s_f_p_pOEYwq8sJr0iI3su8CP4m2ubJaAu_pApzFPk1Au5Yafpui4RsfqdF6k0oXcCY1HmoCwBYn44nThB9TfV7MGtOL4WOLolPk13hEsWuFniEu4oSby9hwrATWWZ9Ms3FRHNd3Lkh2hbBs2T0j1_p9QfTM55gFXa99jZpfC2AOrAdoUsvPF9PY1Ab0nQisG3XlnDcZz8gUyAf80Ydd9KFGdZHIocHi9DHp9OZhgG7vmGHrPGa07FwEkJ5FuEESuISe_fth5Uhfc2etC7bjGxpJzUFAJyWedpUpsQNCD93Ai0GJRBsZW08ceaumm1LSozHQRABmqTxOpd5qGTNyctC3hO5GvvGEvRp3x_pInd2oKxPIjwroQBCOht_fRfO4PKr9vaPYX7E_f0M530qF_fMqPrSh8T7yHGfDUo0ral6G_fuvhJ3f7_fRHGSg713KjPUq_pi_fMeGIC2e8e_pDE2QhrfBpIS73YOZOAj6Wd0WpW1lY34KaovQfHhjcr0fNSVoxNNDYtr_p2jvyb7sliE7em0saLelRz2fvNVa9MD62wRBsd2P4yyOM2GOdj4ZULn24nRmmlxgRjoR8kJbLEKKL0mcvwKnXQdpWy0rSA16wlwRJum224q6z6vBVCg4eYQtY6E4Meh8ZHwUvHI9cSdkEmxC4tBrVId7r0qDWf5S6j8ttri9IJBbVcmpdDcYh7FHxI7IH_fAG0KphC",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-06-15T17:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"departureDateTime": "2018-06-15T15:10:00",
					"flightNumber": "1836",
					"aircraft": "Boeing 757-300",
					"aircraftType": "Jet",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 531.6,
			"arrivalDateTime": "2018-06-16T00:13:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-06-15T19:42:00",
			"destination": "LAX",
			"downPayment": 177.2,
			"id": "346b40f3-cb8c-423f-84cd-2eada553380d",
			"origin": "ORD",
			"ppnReturnBundle": "_eJwN0keibEoAANAFGciKwR9oObccZtSlxJa1tvr3zxoOBHVVQoak4h8i_fdqreIk7FAoynoXDLWfbdDMuQ45Tspj4PNxPQiIe5VdnUiMDBdJDX4TOaJWJwlyitrCtG27XciRCiCUt9nTE2_pCSnfsUQjDSy8Lp7rs1Gtkn_fjya7DXp8wROzu_fZVthFndHBAr2CU4jre_fSmj6Zx0tm5rgl5yt_fGmMQieCnsaT8QYj_pPEDHhMqOsYL7afox7DXdgHH_pq_fMraMOnrnsyRL9JGgcn1F_pAzJVq4Nu2g7mGmXl_ffRTRmmOSk1OpN0ajNP_fwsawQOqM4MLdLOZKz50pB6M33ldkGOLPhXYzNyecauejToIwDgL0hH_f2_friXWKgs0VUoNNvkmX_fhpcpJWgDsc54marEYw964k3cjdYBp8jAxrDyVe_pJyEQxYYld0RrEnkfH8u852QU52u8cqwFzl6zgp_pVQItuImzzWRc7NOslQky2UL_fFXRFmP6pHeyypWqV0NRr9RJ1U1Pf33Qt_pWk5pBqdmGKxgEvHonbCVFgizq4VO_f_flQ1bJiNpPYfZZX_pDwVdbkvzsxt83RfYzOquNeiop_psRBvvoEdL_p1u7dli4V9h_fTqH8MyT9iQYH_fME5uPu_feCbI2N9OULDxsd6D27jHvmpVHnGFGxzlI_fpnlhj690E7F0hXhR65bF1DFT84BHwuQKgyvzuYunCTUeqwMxK5g3Lagbm8svALMxnCmaQlM_pjYZZP8lZxRWnARiTXaruWWCVfNaduBRNpnTMbGKz5xJZK7WmAuMo3NWuLOL7KSrnj_f6CeHimhHVuSJyh9RDJD8WH0gli6VKCnokobJXfOosOLN_fcyO0wf3LPDaAYWMVW83oGCUCtQjabeq6mdgc3eXqvwpMi9ENgR12r1iTBefxlLR2rtpAyuonu2trApkSmM4nedxp_fBL0tlQqkNxak_pZBzxMu5ABPLtxqje9cIHsk3p8gPrLbe8Z_ptLDBsaNPVgaW1YqqzzVAJGe31gTws_fsrZM4C1BeQ8GpbAuQ4iArm_f9yVgjWm1XmYaRJ38dZXos8P3VQ0E_pHp4z5YsFLqG_fTDwtK9kYvUJcVf9uhVqZnpf_p_f3088dicBBXFnqC3BU8XFCHQ3i1rmfq2efmZrPKdiOUdXacYmIj5V_pR0sTsNVNfRIaxr76w5N1lINPdbio9IyN3lLlNbaq_fDw8RoZDs0P63r6J67itwVr_f3Vw22uQxhOlY1U5OVHy_fSCOqWLj6sNZbixEiZWOJTa4qEleE02xHlDkYErlXuDxJEuUuY5ewpuTvpl_pvOia_pe8fW9ilOw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-06-15T21:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"departureDateTime": "2018-06-15T19:42:00",
					"flightNumber": "269",
					"aircraft": "Boeing 737-800",
					"aircraftType": "Jet",
					"destination": "DEN",
					"destinationAirportName": "Denver Intl Airport",
					"destinationAirportCity": "Denver",
					"destinationAirportState": "CO",
					"destinationAirportCountry": "United States",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-06-16T00:13:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"departureDateTime": "2018-06-15T22:50:00",
					"flightNumber": "815",
					"aircraft": "Boeing 757-300",
					"aircraftType": "Jet",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "DEN",
					"originAirportName": "Denver Intl Airport",
					"originAirportCity": "Denver",
					"originAirportState": "CO",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 579.6,
			"arrivalDateTime": "2018-06-15T16:10:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-06-15T11:50:00",
			"destination": "LAX",
			"downPayment": 193.2,
			"id": "1e399385-1569-4d37-afdd-74d74fc0f20f",
			"origin": "ORD",
			"ppnReturnBundle": "_eJwN0sfWa1AAQOEHMlCOOriDINGJ7pgRLXoNx9Pf_fw32_ptaueK6sqirDRIvesfoyJ42tlQkeDngu2r2oZaD61n3ksScYek7G1xzEZ_fLzPNC8dHLV_pPG0DyTC6KZ1ltGjo3l_fcrY0XqT5YjFHzsmylVwbV2_fndVpmt25kcuBodU6D3zFAtbeiLPQ3tQDzjbq6QUYqU8Z1YZPzo37x26aVqVrHuhGX3AvlJanga3M_fiVXlD4wlYNOtQk_fQETTo3UCYZWRaLdHFs2U272l_fvcUwdnuHkbbDYzVshcdGfjHBLjPm8gQVhWrH2oy0z64x4Lh3096l2zYjAGSJ5OywbfBFvFLaftSs_fG_fyuBsK515WZlQYl58sLiHcihh94xHUpdVM7UOZmhN74b2T3EsZjG2wz_pEQmk0X_fFyzWOWRsqZBgVE_pps6hwRJ1WeyQZ2a9yvaHHD7Rz1tVY2axmOn4TKp29fofQy_p6aetylIQovlxY_fefPhIayq9GLilLK0qlEjT8eyXMAPv1J8pqKx_pBRG3VNH94U5I2LiqDzqMZwoNfU1LcdG4bt3t_pGb8ABAqI7WUmNll_pAZl_piTe9s_pjldUQrCYZJDPsZf3sWunIUmuQsKiqaiXsRp4UqNftjIjuO_ppeZhkLWsWZAeNNlZBIMkSTVyeHQ82DMtEAuGvJa8JBbRhS6jUFXOpdIPdNScBJt3vDrNoNdzQW_pgsUeXCJ_fnftWk8CrewO3m89KdD1gpwo8mljNOfonlK4GDq9udy07TyKNd2qE4PFeBviGtsEMO_fUc7ebbb9m16fjT_ftuqS7AJe_fu0W1zpFoR_pcGPmuVIkt2VvmoYteqV6JnyUPN9BhdgOXCzjK4VBdNmoEZes4Uxp6k3Eee_pHsapaCbjcqL8U0jRiG7VwFswQhjQmPLZ_p_f30iebZh_p_f5oCkwvDNuHS5g1q9W_fY3xXJBk2GxKbFTDG2_pE1Ol39UXewYbtlLjuDQOk6DMRvFTQJ4fyKbicU3QUVQTcO6NNT5h4ryg_p48_fAjm2g8g3MaSyivchWBEVI3Pue5FhS8Q8Qv84mIzKT0_fKGbyHCRVI8_pLo263j7IabeyoyXxSBGdTmb5jjCarC4TxzVxUMsUdizXAaX6mcfXOe4IJtUtKvFTGd67yaVC9Me4mWHwhUEKlR47vmXNKA6zotcF11E20Og1lxIt9PeroYmmBXabPtRxgjymM3qlbuJTwaRXPTc_fjGQ9FSvPiVBXiiHYtQ5aDOC2qc3G6ioLc_p8FZv7aeF1P6ek_fAKK1ozXqdhWAEny1e5oMzpNsfv89Xa8l_p8Zp29XpI7OK18N9_fxaqqiw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-06-15T13:57:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"departureDateTime": "2018-06-15T11:50:00",
					"flightNumber": "2680",
					"aircraft": "Boeing 737-800",
					"aircraftType": "Jet",
					"destination": "SAN",
					"destinationAirportName": "San Diego Intl Airport (Lindbergh Field)",
					"destinationAirportCity": "San Diego",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-06-15T16:10:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"departureDateTime": "2018-06-15T15:14:00",
					"flightNumber": "6035",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "SAN",
					"originAirportName": "San Diego Intl Airport (Lindbergh Field)",
					"originAirportCity": "San Diego",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 579.6,
			"arrivalDateTime": "2018-06-15T19:04:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-06-15T13:30:00",
			"destination": "LAX",
			"downPayment": 193.2,
			"id": "b6a32d50-5b3d-4a07-acc4-35ab83d9c4fc",
			"origin": "ORD",
			"ppnReturnBundle": "_eJwN1Leho0AAANGCCBDCBxcgYFnhPYhMeLs4Yau_f38ObKYiiZB9pChQQ6K4nLUJaJ4yhW1_ftcxl6IfBWHb74fHi8qY_poccvjQ6gYzoiXl5z79mTdafF0dwG5ZhM_pGkgL76IONSuiBE0eRo9rGE8XTMpq_pSMZ8Vwav_pE6Vm2fnE0yXsoYVNRtwPc9qPk3wKTftx6mg_pcFlhAQr6a_pGeLrKTieomKN4jqK0S3IvjipKmGrV7r6uwHTjgdxu0ViydHW5fr0xPcbMmAyd6snr9eEbqUK_pf1LX7wlVoyqcWoTd9fxxG3socQ3Wz_pBA8KTwNE2Ei9oH8Dpzu_fPG_p_f7_pqiN3x1Y4B33SY5mwLa30JO6CEYsitVYIVfGhkoc8QvasJTZEUdedKCKM9EKoKxffO9KixZ07xRZwOQJJctfKC88zcK3PbTcKp0iw1ghbS_fvOsm_f6AKSt87wNTOEUBBeWsfRyvNQRzuQ6y8qOe1zb8thTQHqONK2kkNbVomyL5NG2WRdLbqcWz48dUtsb6yQ2fIrOVl1qdoZxv_fecz5qttz6XWU833pSUeZXqX1Cr3rPTsCSk7QhFkOsgEuqQ8Uu3mOZjme7Xh6rr0_feK9U_fJZOQchHjCj9PeH64QOidRzayMcGlICaBoqZORZoVrPflOO4am0XiWW8_pTkXCtvuzjZRDvrm_paGQV4N_fEEuLB89dn5JehHsNuq_pRtsO1SVq_pGf3RqJIh2f_fuwqqEjq_fXOahsmTuw1rITo12WsD0dY6fVXXOxLwsVNxMy2ADSz9yeGMLy3jew4zchR_fHSmK6dm2fktouukpSDIfg9RpItgMRTGTizGnEM36FilMbW7zX6FBOSqZQdu2M1H_fNMcTH_pEfzrwK8a2s5CE6_fMGv_f56JybW2IWl0dATzp_puF4CVmg6vQ3ZNRwxSE_prEFbIwwYlTbq0H2_fCZJljipFgzrypaiqu7SHVL7PTJPuLEgLB7eNhPL4s_pnNs0MQ1mdmCgk2gDTZv6ZiBzrkga3yJ31T4aJu3M_fDHUBQ2OCtUl559lL_pepKcDN_f3YwoymzaqHeOhY3HD4iyuc7zkerEHFsBu_pWT_p_p_fCWROC7QwjyexpGFZTbqDlC7oARzuEOzaD8kpnmEzd06lUZAr8OtVYwIRsEXrjAVLoY4VFuiUzJPcTkhWLmnvJPsjILCi7EVhR8aPo0VPARRNwtVNRE03SR3TU2av_fTWt5pJKCwmWiv72s5h4mDh0cxzJYz3pajmac67YtmtYPHVwRvEyfRjb43Bd70rdVLFxjxql4KpsNdN0Rjqsgngt24xpdUr8pTmh6vPvP2q5qSo",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-06-15T15:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"departureDateTime": "2018-06-15T13:30:00",
					"flightNumber": "1168",
					"aircraft": "Boeing 737-800",
					"aircraftType": "Jet",
					"destination": "SAN",
					"destinationAirportName": "San Diego Intl Airport (Lindbergh Field)",
					"destinationAirportCity": "San Diego",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-06-15T19:04:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"departureDateTime": "2018-06-15T18:06:00",
					"flightNumber": "3007",
					"aircraft": "Canadair Regional Jet 700",
					"aircraftType": "Jet",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "SAN",
					"originAirportName": "San Diego Intl Airport (Lindbergh Field)",
					"originAirportCity": "San Diego",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			]
		},
		{
			"totalCost": 580.8,
			"arrivalDateTime": "2018-06-15T21:47:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-06-15T14:25:00",
			"destination": "LAX",
			"downPayment": 193.6,
			"id": "c9caee42-0d45-4e95-b79a-e4920d78b166",
			"origin": "ORD",
			"ppnReturnBundle": "_eJwN08WBg0AAAMCCeCwBFnnisrjDDwseNAmh_prseZh4MXjAUS_p15PQRPIL3pFptVmUqrUpsZijDZZIWrxfB9Nkay0L7Tl1EspLgTXm14Xvp_pEm0ukLewA2CmR9fnuAQlLiLVMJJ_f1F5WXxlvceAIFif5LSsrbU6Vzd0km_fFWrMrsI4jnIAFbcjWS6VlXubhPv5_pN2Sm1RedfJSTJMF_fUxPvK41YpkXw6kRPE7Id9Ca0x4QkpNXUZK2WHM_pmpYHG93fCshKEhzS0mKAFigbAmyw8NwvsXnCKuCxJgjSK_pVrb3sdtRDTsPxm2MLBuiIiLMBFvwhxiMJ_f0Oi6RS8jiNqfJOUQEyJq58L9PxDzqZuomHg9x3EzIRKa8R7cT5qBJRE1tkrhJ8NjgBsM9wFyfSDV4SpwXTzp7oTngAvgp5z_puresouYsOBEEa_f9Ia7C3rn9IXc_f_fDlgY6h3d7R8cHLNRNo_fsbRgrtuqm7uZhGC6ErvI9DpmZ9W53UXAmv8NtJEp_p1BtZ1r1eF_p5sak3by900eXS_f2TYnaHGA_pWBc79VTivaK2fPagOHnQyc_fENo5T2QCAKiVR1MUzvSMhrQOnaOccLP9iCjdncPnX57EsjCJQi4fSb57VOdbwTh5LoEp_fYnpA1NF0wYzAMP9edSEYBNvACl8QSy_pCyezyXC4aR1boih7YQdFKkofeYmfn3Wu0PqEQ6XKHcbOy0Sw_ptJyL5YkmPKxRuFfNYKMqshVPYqcLMKEkvU8uCYK7f7gu7s3VTspyhvqvzESnntPsSTW3IxEqELZekHvk1FEtnBupjS_pruzJwVrKaQFYHmvzm2Anhmfijy4vwhPKtJUBXlZm28lga2ximPBgkxBJBTlhd_p77hWLeA2JX_fRGCy_fHg7FC0pMmfU7KESDGfsjrZ4_pOX1CEgRPS12f0gQn_fGEUetOykO6fShw_pNDlUPmg3B0JecX6K3dVAriYZFve4vjpD2GKS9niSBhSBjRTe5xzxgvTPWw52Znp35O0R2X4QXiPLCyJytqHRe1GSs44LUmCv1t4VGPYQkWot_f1WPlLp_pZAJsI_fCqnjNfslyLEX1OcZmZ3rf6zMpVSH5g5eKht5JA2O7VG1_pG5LJg_fyr3rJ4Pl14yfx01bOuXZ1m3OlVXeMvexLF1QgL1AsXSIpb1HGutYfGbFmzjSKbYeagQgURWO_fYVKcOSG0YUkslyl1u0kMmwkv84FFPQMp1R4eDk7pPDUc3hkTyRjCq3ZHXSkCAb8ZUSrm4GEeb24WkGEPmaxd7DFUda0uzC1wfS71vnG_fuz4R_pFN5ju",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-06-15T16:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"departureDateTime": "2018-06-15T14:25:00",
					"flightNumber": "2346",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-06-15T21:47:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"departureDateTime": "2018-06-15T20:25:00",
					"flightNumber": "2697",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "DFW",
					"originAirportName": "Dallas/Fort Worth Intl Airport",
					"originAirportCity": "Dallas",
					"originAirportState": "TX",
					"originAirportCountry": "United States"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ../server/test/mocks/RoundTrip_Departing.json
// module id = 598
// module chunks = 0